<template>
  <div class="page">
    <vue-progress-bar />
    <router-view />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'App',
  data() {
    return {};
  }
});
</script>
